export const NUMBER_REGEX=/^\d*[1-9]\d*$/
export const ZERO_POSITIVE=/^(0|[1-9][0-9]{0,9})$/
export const ALPHA_NUNERIC=/[^a-zA-Z0-9]/
export const STRING_ONLY = /[^A-Za-z]+/g